<script lang="ts">
	import { Text, DashSelectCard, IconButton, Popover } from '@Shelly/shelly-design-system/index';
	import type { DashWidgetEditType } from '../../dash-types';
	import { format } from 'svelte-i18n';
	import { SystemScreenBreakpoints } from '@Shelly/shelly-design-system/helpers/enums';
	import { edit } from 'src/stores/ui/edit_lists';

	export let editItem: DashWidgetEditType;
	export let hideSeparator = false;

	let windowInnerWidth: number;

	const checkIsMobile = (windowInnerWidth: number) => {
		const currentIsMobile = windowInnerWidth <= SystemScreenBreakpoints.MOBILE_MAX;
		return currentIsMobile;
	};

	$: isMobile = checkIsMobile(windowInnerWidth);

	$: if (isMobile) {
		editItem.col = 'right';
	}
</script>

<svelte:window bind:innerWidth={windowInnerWidth} />

{#if !isMobile}
	{#if !$edit && !hideSeparator}
		<hr class="mb-l mt-l" />
	{/if}

	<div class="d-flex align-items-center mb-s gap-xs">
		<Text styleType="label-large" class="text-uppercase text-color-muted pl-s-plus">
			{$format('label_widget_select_section', { default: 'Select section' })}
		</Text>

		<Popover type="hover" hideCloseBtn placement="top">
			<IconButton aria-label="IconButton Example" icon="fa-solid fa-circle-info" variant="help" />

			<Text styleType="body-small" slot="customContent">
				{$format('label_widget_select_section_info', {
					default:
						'Choose which section your widget to appear in. You can reorder widgets anytime in edit mode.',
				})}
			</Text>
		</Popover>
	</div>

	<div class="d-flex gap-m">
		<DashSelectCard
			class="flex-1 min-width-0"
			title={$format('label_widget_left_section', { default: 'Left Section' })}
			image={`./images/dash/dash-slect-left-col.svg`}
			selected={editItem.col === 'left'}
			on:click={() => {
				editItem.col = 'left';
			}}
		/>
		<DashSelectCard
			class="flex-1 min-width-0"
			title={$format('label_widget_right_section', { default: 'Right Section' })}
			image={`./images/dash/dash-slect-right-col.svg`}
			selected={editItem.col === 'right'}
			on:click={() => {
				editItem.col = 'right';
			}}
		/>
	</div>
{/if}
